"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactVirtualized = require("react-virtualized");

var SkuCardVirtualizedList =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(SkuCardVirtualizedList, _Component);

  function SkuCardVirtualizedList() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, SkuCardVirtualizedList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(SkuCardVirtualizedList)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.skuCardRenderer = function (_ref) {
      var index = _ref.index,
          key = _ref.key,
          style = _ref.style;
      var _this$props = _this.props,
          skuCardRenderer = _this$props.skuCardRenderer,
          skuCardList = _this$props.skuCardList;
      var skuInfo = skuCardList ? skuCardList[index] : {};
      var content = skuCardRenderer(skuInfo);
      return _react.default.createElement("div", {
        key: key,
        style: style
      }, content);
    };

    return _this;
  }

  (0, _createClass2.default)(SkuCardVirtualizedList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          skuCardList = _this$props2.skuCardList,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["skuCardList"]);
      return _react.default.createElement(_reactVirtualized.AutoSizer, null, function (_ref2) {
        var width = _ref2.width,
            height = _ref2.height;
        return _react.default.createElement("div", null, _react.default.createElement(_reactVirtualized.List, Object.assign({
          style: {
            outline: 'none'
          },
          rowRenderer: _this2.skuCardRenderer,
          width: width,
          height: height,
          rowCount: skuCardList ? skuCardList.length : 0,
          rowHeight: 60
        }, rest)));
      });
    }
  }]);
  return SkuCardVirtualizedList;
}(_react.Component);

var _default = SkuCardVirtualizedList;
exports.default = _default;